// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"fdaf4b7b","297":"8de3e5e4","8129":"a9076a03","8510":"f728204c"}[chunkId] + ".chunk.css";
};